import { NumberFormatStyle } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
export interface AdmissionInsuranceParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}
export interface AdmissionInsurance {
    id?: any;
    Gender?:string;
    PolicyId: string; 
    PolicyHolder:string;
    policyStartDate:any;
    policyEndDate:any
    RelationTobeneficiary:string;
    PrimaryBeneficiary:string;
    PrimaryBeneficiaryEmpId: string;
    InsuranceClaimNo: string;
    InsuranceMemberId: string;
    RegId: string;
    PayerId: string;
    AdmissionId: number;
    branchId:string;
    TenantId:string;
    CorpEmpName:string;
    CorpDepartment:string;
    CorpRelation:string;
    CorpDesignation:string;

    parameters?: AdmissionInsuranceParameter[];
    links?: any;
  }
  
  export abstract class AdmissionInsuranceData {
    abstract getall(url: string): Observable<any[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: AdmissionInsurance): Observable<AdmissionInsurance[]>;
    abstract update(url: string, data: AdmissionInsurance): Observable<AdmissionInsurance>;
  }
  